import React from "react"
import Button from "@material-ui/core/Button"
import ContextMenu from "components/ContextMenu"
import FileLink from "components/Table/components/FileLink"

/** Utils */
import { fromUnixDateTime } from "utils/date"
import { RolesCategory } from "config/Common/Roles"
import { checkValue, checkDate } from "utils/helpers"
import ContextItems from "./ContextMenu"

const TableHeaderColumns = (handleTimeout: Function) => [
  {
    fixed: "left",
    disableFilters: true,
    columns: [
      {
        width: 70,
        Cell: (row: any): JSX.Element => {
          return (
            <ContextMenu>
              <ContextItems data={row?.original} />
            </ContextMenu>
          )
        },
        filterable: false
      }
    ]
  },
  {
    Header: "",
    columns: [
      {
        Header: "Name",
        id: "name",
        accessor: (c: any) => checkValue(c?.name),
        Cell: ({ original }: any) => checkValue(original?.name),
        width: 250
      },
      {
        Header: "Category",
        id: "category",
        accessor: (c: any) =>
          checkValue(c?.user_role_category, RolesCategory[c?.user_role_category]),
        Cell: ({ original }: any) =>
          checkValue(
            original?.user_role_category,
            RolesCategory[original?.user_role_category]
          )
      },
      {
        Header: "Position",
        id: "position",
        accessor: (c: any) => checkValue(c?.user_role_name),
        Cell: ({ original }: any) => checkValue(original?.user_role_name)
      },
      {
        Header: "Time-in",
        id: "timein",
        accessor: (c: any) =>
          checkDate(
            c?.attendance_date_time,
            fromUnixDateTime(c?.attendance_date_time)
          ),
        Cell: ({ original }: any) =>
          checkDate(
            original?.attendance_date_time,
            fromUnixDateTime(original?.attendance_date_time)
          ),
        width: 250
      },
      {
        Header: "Photo",
        id: "position",
        sortable: false,
        filterable: false,
        accessor: (c: any) => checkValue(c?.photo?.key, c?.photo?.file_name),
        Cell: ({ original }: any) =>
          checkValue(
            original?.photo?.key,
            <FileLink
              url={original?.photo?.url}
              name={original?.photo?.file_name}
              fileType={2}
            />
          )
      },
      {
        Header: "Remarks",
        id: "remarks",
        accessor: (c: any) => checkValue(c?.remarks),
        Cell: ({ original }: any) => checkValue(original?.remarks),
        width: 250
      }
    ]
  },
  {
    fixed: "right",
    disableFilters: true,
    columns: [
      {
        width: 130,
        Cell: ({ original }: Record<string, any>): JSX.Element => {
          if (original?.attendance_type === 2) {
            return <div />
          }
          return (
            <Button color="primary" onClick={(): void => handleTimeout(original)}>
              TIME OUT
            </Button>
          )
        },
        filterable: false
      }
    ]
  }
]

export default TableHeaderColumns
